module.exports = __webpack_public_path__ + "img/left-corner.a7e57748.svg";